import { useState, useEffect } from 'react';
import { getUserAccount } from '../services/auth';

const useUserShippingAddress = () => {
  const [shippingAddress, setShippingAddress] = useState(null);

  useEffect(() => {
    getUserAccount().then(({ shippingAddress: sa }) => {
      setShippingAddress(sa);
    });
  }, []);

  return shippingAddress;
};

export default useUserShippingAddress;
